/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function($) {
	
	// Remove empty P tags created by WP inside of Accordion and Orbit
	$('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( $(this).innerWidth() / $(this).innerHeight() > 1.5 ) {
			$(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
			$(this).wrap("<div class='responsive-embed'/>");
		}
	});

	// Prevent Dropdown buttons in Main Nav from doing anything when clicked
	$('.menu-item a[href="#"]').on('click', function(event) {
		event.preventDefault();
	  });
	
	const $menu = $('#off-canvas'); 
	const $overlay = $('#off-canvas-overlay');
  
	function toggleOverlay() {
	  const isHidden = $menu.attr('aria-hidden') === 'true';
	  $overlay.attr('aria-expanded', !isHidden);
	}
  
	// Monitor changes to the `aria-hidden` attribute
	$menu.on('attributeChange', function () {
	  toggleOverlay();
	});
  
	// Initial setup: set overlay state based on current `aria-hidden` value
	toggleOverlay();

	// Specialty Materials horizontal bar graph
$('.sg-bar-graph .material-buttons button').on('click', function () {
    // Remove active class from all buttons and add to the clicked one
    $('.sg-bar-graph .material-buttons button').removeClass('active');
    $(this).addClass('active');

    // Get the widths from the data attribute of the clicked button
    const widths = JSON.parse($(this).attr('data-bars'));

    // Update bar widths and switch active class
    $('.sg-bar-graph .bar-graph .bar').each(function (index) {
        $(this).css('width', widths[index] + '%');
    });

    // Highlight the bar with the largest width
    $('.sg-bar-graph .bar-graph .bar').removeClass('active')
        .eq(widths.indexOf(Math.max(...widths))).addClass('active');
});

$(".sg-cost-graph .material-buttons button").on("click", function () {
	// Remove active class from all buttons
	$(".sg-cost-graph .material-buttons button").removeClass("active");
	// Add active class to the clicked button
	$(this).addClass("active");

	// Determine the index of the clicked button
	const index = $(this).index() + 1; // +1 to match `.bar-*` class numbering

	// Remove active class from all .bar-* elements inside the SVG
	$(".sg-cost-graph .material-cost-graph [class^='bar-']").removeClass("active");

	// Add active class to the corresponding .bar-* element in the SVG
	$(`.sg-cost-graph .material-cost-graph .bar-${index}`).addClass("active");
});

	// Element: "Read More" Toggle Buttons
	var instance = ['1', '2', '3', '4', '5', '6', '7', '8', '9' ];
	$.each( instance, function( i, val ) {
		$('.toggle-' + val).click(function(e){
			e.preventDefault();
			$('.showHide-' + val).slideToggle();
			$(this).text( $(this).text() == 'read more' ? "read less" : "read more");
			$(this).toggleClass('show-active');
		});
	});

	// Element: Mobile "Read More" Toggle Buttons
	if ($(window).width() < 640) {
		var mobileInstance = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12' ];
		$.each( mobileInstance, function( i, val ) {
			$('.mobile-toggle-' + val).click(function(e){
				e.preventDefault();
				$('.mobile-showHide-' + val).slideToggle();
				$(this).toggleClass('mobile-show-active');
			});
		});
	}
	
	if (window.location.pathname === '/sitemap' || window.location.pathname === '/sitemap/') {
		$('#primary').css({
		  'max-width': '1200px',
		  'margin': '48px auto',
		  'padding': '0 15px'
		});

		$('#content').css({
		  'list-style-type': 'none'
		});

		$('#content li a').css({
		  'color': '#000',
		});

		$('#content li').hover(
			function () {
			  $(this).css('text-decoration', 'underline');
			},
			function () {
			  $(this).css('text-decoration', 'none');
			}
		  );
	  
		$('#content').prepend('<h1>Sitemap</h1>');
		
		$('#content h1').css({
			'color': '#112A4C',
			'margin-bottom': '32px'
		});
	}

	  $('#state-selector').on('change', function () {
		var selectedState = $(this).val();
	
		// Hide all state links
		$('.state-links').removeClass('active');
	
		// Show the links for the selected state
		if (selectedState) {
		  $('#' + selectedState).addClass('active');
		}
	  });

	  $('#TOC a').on('click', function (e) {
        e.preventDefault();

        // Get the target element's offset
        var target = $($(this).attr('href'));
        var offset = target.offset().top;

        // Adjust for custom offset (e.g., 50px for fixed header)
        var customOffset = 80;

        // Scroll to the target with the adjusted offset
        $('html, body').animate({
          scrollTop: offset - customOffset
        }, 500);
      });

	$(window).on('scroll', function () {
		$('#top-of-stick [id]').each(function () {
			var element = $(this);
			var anchor = $("a[href='#" + element.attr('id') + "']");
			var elementPosition = element.offset().top;
			var scrollPosition = $(window).scrollTop();
	
			// Check if the element is 100px away from the top of the viewport
			if (elementPosition <= scrollPosition + 100 && 
				elementPosition + element.outerHeight() > scrollPosition + 100) {
				
				// Remove the 'active-anchor' class from all anchors
				$("a").removeClass('toc-active-anchor');
				
				// Add 'active-anchor' class to the current anchor
				anchor.addClass('toc-active-anchor');
			}
		});
	});
	
	$('.home-our-services a.kb-section-link-overlay').on('mouseover', function () {
        $(this).siblings('.kt-inside-inner-col').find('.wp-block-kadence-advancedheading').css('text-decoration', 'underline');
    });

    $('.home-our-services a.kb-section-link-overlay').on('mouseout', function () {
        $(this).siblings('.kt-inside-inner-col').find('.wp-block-kadence-advancedheading').css('text-decoration', 'none');
    });

		$('.google-map iframe').attr('aria-label', 'Google maps to Brothers Gutters Near You');
	

}); 



